import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";
import Credin from "../../assets/Credin Logo (1).svg";
import Logo1 from "../../assets/C pannel Log in screen-01 1.svg";
import Logo2 from "../../assets/C pannel Log in screen-02.svg";
import Logo3 from "../../assets/C pannel Log in screen-03.svg";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../App";
import { version } from "../../App";
import ForgotPassword from "./Components/ForgotPassword";
import Cookies from 'js-cookie';

export default function Login() {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [otpDiv, setOtpDiv] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  const [authToken, setauthToken] = useState("");
  const [timer, setTimer] = useState(30);

  const [isResendDisabled, setIsResendDisabled] = useState(true);
  //eslint-disable-next-line
  const [forgotPassword, setForgotPassword] = useState(false);

  const navigate = useNavigate();

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const hostName = window.location.href
  const [ip, setIp] = useState('');
  const fetch = async () => {
    const { data } = await axios.get('https://api.ipify.org')
    setIp(data);
  }

  useEffect(() => {
    fetch()
  }, [])

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const showOtpHandler = () => setShowOtp((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const startTimer = () => {
    setTimer(30);
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 1) {
          clearInterval(countdown);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  const handleSubmit = async () => {
    try {
      setOpen(true);
      let latitude;
      let longitude;
      const fetchLocation = () => {
        return new Promise((res, rej) => {
          navigator.geolocation.getCurrentPosition(
            (location) => {
              latitude = location.coords.latitude;
              longitude = location.coords.longitude;
              res();
            },
            (err) => {
              console.log(err);
              toast.error(err.message);
              setOpen(false);
            }
          );
        });
      };
      if (url !== "http://staging.cpanel.api.credin.in") {
        await fetchLocation();
      }
      const req = {
        email: email,
        password: password,
        ip: ip,
        hostName: hostName,
        latitude:
          url === "http://staging.cpanel.api.credin.in"
            ? "22.30516956900325"
            : latitude,
        longitude:
          url === "http://staging.cpanel.api.credin.in"
            ? "73.17319436857136"
            : longitude,
      };
      const res = await axios.post(url + "/user/lmslogin", req);
      if (!res.data.auth) {
        setOpen(false);
        toast.error(res.data.message);
        return;
      }
      // toast.success(res.data.message);
      setauthToken(res.data.token);
      setOtpDiv(true);

      const sendOtpReq = {
        token: res.data.token,
        email: res.data.email,
      };
      const sendOtpRes = await axios.post(url + "/user/otpsend", sendOtpReq);
      if (!sendOtpRes.data.auth) {
        setOpen(false);
        toast.error(sendOtpRes.data.message);
        return;
      }
      toast.success(sendOtpRes.data.message);
      startTimer();
      setTimeout(() => {
        setIsResendDisabled(false);
      }, 30000);
      setOpen(false);
    } catch (err) {
      console.log(err);
      setOpen(false);
      toast.error(err.message);
    }
  };

  const resendOtpHandler = async () => {
    try {
      setIsResendDisabled(true);
      setOpen(true);
      const sendOtpReq = {
        token: authToken,
        email: email,
      };
      const sendOtpRes = await axios.post(url + "/user/otpsend", sendOtpReq);
      setOpen(false);
      if (!sendOtpRes.data.auth) {
        setOpen(false);
        toast.error(sendOtpRes.data.message);
        return;
      }
      toast.success(sendOtpRes.data.message);
      setOpen(false);
      setTimeout(() => {
        setIsResendDisabled(false);
      }, 30000);
      startTimer();
    } catch (err) {
      setOpen(false);
      console.error(err);
      toast.error(err.message);
    }
  };

  const verifyOtpHadnler = async () => {
    try {
      setOpen(true);
      const verifyReq = {
        token: authToken,
        email: email,
        user_otp: otp,
      };
      const verifyRes = await axios.post(url + "/user/otpverify", verifyReq);
      setOpen(false);
      if (!verifyRes.data.auth) {
        toast.error(verifyRes.data.message);
        return;
      }
      Cookies.set('Token', authToken, { expires: 1 });
      Cookies.set('Email', email, { expires: 1 });
      toast.success(verifyRes.data.message);
      setTimeout(() => {
        navigate("/home");
      }, 2000);
    } catch (err) {
      console.log(err);
      setOpen(false);
      toast.error("Login failed : " + err.message);
    }
  };

  const passwordEnterHandler = (e, field) => {
    if (e.key === "Enter" && field === "password") {
      handleSubmit();
    }
    if (e.key === "Enter" && field === "otp") {
      verifyOtpHadnler();
    }
  };
  //eslint-disable-next-line
  //TODO const forgetPasswordHandler = () => {
  //TODO   setForgotPassword(true);
  //TODO };
  const date = new Date().getFullYear();

  return (
    <div className="main-login">
      <div className="container-login">
        <div className="input-login">
          <div className="credin-logo-login">
            <img src={Credin} alt="Credin Logo" />
          </div>
          {forgotPassword && <ForgotPassword />}
          {!forgotPassword && (
            <>
              <div className="input-item-login">
                <label className="label-login">Username or Email</label>
                <br />
                <TextField
                  className="input-field-login"
                  variant="outlined"
                  required
                  disabled={!otpDiv ? false : true}
                  name="email"
                  onChange={handleEmail}
                  value={email}
                  style={{ backgroundColor: "#F0F4F7", width: "30ch" }}
                  size="small"
                />
              </div>
              {!otpDiv && (
                <div className="input-item-login">
                  <label className="label-login">Password</label>
                  <FormControl
                    sx={{ width: "30ch", display: "block" }}
                    variant="outlined"
                  >
                    <OutlinedInput
                      type={showPassword ? "text" : "password"}
                      size="small"
                      onKeyDown={(e) => passwordEnterHandler(e, "password")}
                      required
                      value={password}
                      onChange={handlePassword}
                      name="password"
                      style={{
                        backgroundColor: "#F0F4F7",
                        fontSize: "1.17rem",
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {/* <button
                    className="forget-password"
                    onClick={forgetPasswordHandler}
                  >
                    Forget Password
                  </button> */}
                </div>
              )}
              {otpDiv && (
                <div className="input-item-login">
                  <label className="label-login">Enter OTP</label>
                  <br />
                  <OutlinedInput
                    className="input-field-login"
                    variant="outlined"
                    required
                    name="otp"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    type={showOtp ? "number" : "password"}
                    maxLength="1"
                    onKeyDown={(e) => passwordEnterHandler(e, "otp")}
                    onChange={(e) => setOtp(e.target.value)}
                    value={otp}
                    style={{ backgroundColor: "#F0F4F7", width: "33ch" }}
                    size="small"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={showOtpHandler}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showOtp ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <button
                    disabled={isResendDisabled ? true : false}
                    className="resend-otp"
                    onClick={resendOtpHandler}
                    style={
                      isResendDisabled
                        ? { color: "grey" }
                        : { color: "#034ea1" }
                    }
                  >
                    Resend OTP {isResendDisabled ? `(${timer})` : ""}
                  </button>
                </div>
              )}
              {!otpDiv ? (
                <button onClick={handleSubmit} className="btn-submit-login">
                  Login
                </button>
              ) : (
                <button className="btn-submit-login" onClick={verifyOtpHadnler}>
                  Verify OTP
                </button>
              )}
            </>
          )}
        </div>

        <div className="svg-login">
          <div className="image-login">
            <div className="slider-container">
              <Carousel
                showThumbs={false}
                infiniteLoop
                autoPlay
                interval={3000}
                showArrows={false}
                showStatus={false}
              >
                <div>
                  <img
                    src={Logo1}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
                <div>
                  <img
                    src={Logo2}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
                <div>
                  <img
                    src={Logo3}
                    alt=""
                    style={{ width: "18rem", height: "18rem" }}
                  />
                </div>
              </Carousel>
            </div>
          </div>
          <div className="para-login">
            <div>
              <p>Loan Management System</p>
            </div>
            <div style={{ fontSize: ".9rem" }}>v{version}</div>
            <div style={{ fontSize: ".7rem", fontWeight: "400" }}>
              All rights reserved &copy; Upkram Technologies Pvt. Ltd. @{date}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
